import { browser } from '$app/environment';
import { writable, derived, type Writable, type Readable, readable, get } from 'svelte/store';
import { matchaCallData } from '$lib/home/store';

let initialValue = true;
if (browser) {
	const value = window.localStorage.getItem('autowithdraw_margin');
	if (value !== null) {
		initialValue = value === 'true';
	}
}

export const AUTOWITHDRAW_MARGIN_FROM_CLOSEPOSITION: Writable<boolean> = writable(initialValue);

AUTOWITHDRAW_MARGIN_FROM_CLOSEPOSITION.subscribe((value) => {
	if (browser) {
		window.localStorage.setItem('autowithdraw_margin', String(value));
	}
});

export const MIN_DEPOSIT_AMOUNT: Readable<string> = readable('50');

let initalAutoSwapValue = true;
if (browser) {
	const value = window.localStorage.getItem('autoswap_stables');
	if (value !== null) {
		initalAutoSwapValue = value === 'true';
	}
}
export const AUTOSWAP_STABLES: Writable<boolean> = writable(initalAutoSwapValue);

AUTOSWAP_STABLES.subscribe((value) => {
	if (browser) {
		window.localStorage.setItem('autoswap_stables', String(value));
	}
});

let initialOPAutoSwapValue = false;
if (browser) {
	const value = window.localStorage.getItem('autoswap_op');
	if (value !== null) {
		initialOPAutoSwapValue = value === 'true';
	}
}
export const AUTOSWAP_OP: Writable<boolean> = writable(initialOPAutoSwapValue);

AUTOSWAP_OP.subscribe((value) => {
	if (browser) {
		window.localStorage.setItem('autoswap_op', String(value));
	}
});
